module.exports = require('../../es/symbol');
